import { render, staticRenderFns } from "./DollarLastestQuotation.vue?vue&type=template&id=8bbd4e60&"
import script from "./DollarLastestQuotation.vue?vue&type=script&lang=js&"
export * from "./DollarLastestQuotation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports